<template>
  <div class="pc-note__editor" v-show="visible">
    <!-- <note-name/> -->
    <!-- <note-tags/> -->
    <codemirror-editor/>
  </div>
</template>

<script>
// import NoteName from '@/components/note/editor/Name.vue'
// import NoteTags from '@/components/note/editor/Tags.vue'
import CodemirrorEditor from '@/components/note/editor/CodemirrorEditor.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    // NoteName,
    // NoteTags,
    CodemirrorEditor
  },
  computed: {
    ...mapGetters({
      preview: 'workbench/current/preview'
    }),
    visible () {
      return !this.preview
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';
</style>
